import * as _4 from 'lodash4';
import { ProgramsQuestionFunction } from '../../data/functions/programs_fn';
import { MajorDataToggleService } from '../../data/services/major_data_toggle_service';
import { MajorSearchService } from '../../data/services/major_search_service';
import { SurveyStepService } from '../../data/services/survey_step_service';
import { ISurveyQuestionItemDTO } from '../../major_explorer_interface';
import { MajorProgram } from './../../data/builders/major_programs_builder';
import { MajorCurrentMajorsQuery } from './../../data/queries/major_current_majors_query';

interface ISurveyProgramFlag {
  showSorting: boolean;
  isLoading: boolean;
}

export class SurveyQuestionProgramsController {
  private mode: string;
  private item: ISurveyQuestionItemDTO;
  private flags: ISurveyProgramFlag;

  constructor(
    private programsQuestionFn: ProgramsQuestionFunction,
    private ngSurveyStepService: SurveyStepService,
    private majorDataToggleService: MajorDataToggleService,
    private ngMajorSearchService: MajorSearchService,
    private ngMajorCurrentMajorsQuery: MajorCurrentMajorsQuery,
    private ProgramsPresenterViewState: any,
    private programSortEnum: any
  ) {}

  $onInit() {
    this.flags = {
      showSorting: this.majorDataToggleService.toggles.salary || this.majorDataToggleService.toggles.hiringDemand,
      isLoading: true
    };

    this.programsQuestionFn.coreInitialize();
    this.programsQuestionFn.loadMajorExplorer().then((programs: any) => {
      this.flags.isLoading = false;
      this.item.custom = programs;
    });
  }

  hasSavedPrograms() {
    return !!this.programsQuestionFn.favoritePrograms ? _4.size(this.programsQuestionFn.favoritePrograms) > 0 : false;
  }

  toggleProgram(program: MajorProgram, save: boolean) {
    return save
      ? this.programsQuestionFn.favoritePrograms.push(program)
      : _4.remove(this.programsQuestionFn.favoritePrograms, { id: program.id });
  }

  isSorted(sortType: string): boolean {
    return this.ngSurveyStepService.activeSortType === sortType;
  }

  getFilteredMajors(): MajorProgram[] {
    const sortOrder = this.ngSurveyStepService.sortOrder;
    const customSortMethod = this.programSortEnum.key(this.ngSurveyStepService.activeSortType).customSortMethod;
    let iteratee = this.ngSurveyStepService.activeSortType;

    if (_4.isFunction(customSortMethod)) {
      iteratee = customSortMethod;
    }

    return this.ngMajorSearchService.getFilteredMajors([iteratee], sortOrder);
  }

  currentView(): string {
    return (
      'capability-ng-major-explorer/src/components/survey_question_programs/survey_question_views/' +
      this.ProgramsPresenterViewState.PROGRAMS.key +
      '.html'
    );
  }

  getSortingText(value: string) {
    return this.programSortEnum[value.toUpperCase()].displayText;
  }

  hasCurrentMajor() {
    return (
      this.ngMajorCurrentMajorsQuery.result.length > 0 &&
      _4.first(this.ngMajorCurrentMajorsQuery.result).nk !== '*UNDECLARED*'
    );
  }

  showRankedMajor(): boolean {
    return !this.ngMajorSearchService.isLoading && this.ngMajorSearchService.hasResults;
  }
}

export class SurveyQuestionProgramsComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/survey_question_programs/survey_question_programs.html';
  public controller: any = SurveyQuestionProgramsController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    mode: '@',
    item: '='
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_question_programs/survey_question_programs_controller.ts